export const GET_SUBSCRIPTION_PLANS = 'GET_SUBSCRIPTION_PLANS'
export const GET_PAYMENT_INFO = 'GET_PAYMENT_INFO'
export const GET_EXCHANGE_RATES = 'GET_EXCHANGE_RATES'
export const GET_PAYMENT_LIST = 'GET_PAYMENT_LIST'
export const SET_CURRENT_PLAN = 'SET_CURRENT_PLAN'
